import Observable from '../lib/Observable.js';
import Promise from '../lib/Promise.js';

class InstitutionFormController {
    static promise(params) {
        var controller = new InstitutionFormController(params);

        return Promise.create(resolve => controller.on('success', data => resolve(data)));
    }

    constructor({env}) {
        Observable.apply(this);

        this.env = env;
        this.dialog = env.getDialog('institution-sign-in-dialog');

        const username = this.env.getUrlParams().getInstitution();

        this.dialog.show();

        if (username) {
            this.dialog.setUsername(username);
            this.dialog.focusPassword();
        }
        else {
            this.dialog.focusUsername();
        }

        this.initEvents();
    }

    initEvents() {
        this.dialog.on('submitGesture', () => this.submit());
    }

    submit() {
        var {username, password} = this.dialog.getState();

        this.dialog.clearErrors();

        if (!username) {
            this.dialog.addUsernameRequiredError();
            return;
        }
        else if (!password) {
            this.dialog.addPasswordRequiredError();
            return;
        }

        this.dialog.setSubmitting(true);

        this.env.getProxy().getInstitution({username, password})
            .then(data => this.trigger('success', data))
            .catch(error => {
                this.dialog.setSubmitting(false);

                if (error.isAuthentication()) {
                    this.dialog.addFormError('Please provide a valid institution name and password to sign in.');
                }
                else if (error.isInactiveRegistration()) {
                    this.dialog.addFormError('This institution’s account has expired. For assistance, please contact your SimplyAnalytics administrator or email support@simplyanalytics.com.');
                }
                else if (error.isUnauthorizedLocation()) {
                    this.env.getDialog('unauthorized-location-dialog').setMessage(error.getMessage()).show();
                }
                else {
                    throw error;
                }
            });
    }
}

export default InstitutionFormController;